import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://piaqvcrmbobzjexoeebr.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBpYXF2Y3JtYm9iempleG9lZWJyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA2MjY2MzgsImV4cCI6MjA3NjIwMjYzOH0.DxSZft73AXTzQZpqm2m7BVrs0BySekotO0R0WsZkOLo'

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";
